import { HubtypeCase } from 'models/hubtype-case'
import { HubtypeUser } from 'models/hubtype-user'

export function isCaseVisibleForUser(
  user: HubtypeUser,
  caze: HubtypeCase
): boolean {
  const userHasVisibilityOfCaseQueue = user.hasQueuePermission(caze.queue_id)

  const userHasVisibilityIfTestCase = user.hasTestCasesVisibility(caze.is_test)

  const isAssignedToUserOrStatusWaiting =
    caze.isAssignedTo(user.id) || caze.is_waiting

  const isNotStatusSolved = !caze.is_solved

  return (
    userHasVisibilityOfCaseQueue &&
    isAssignedToUserOrStatusWaiting &&
    isNotStatusSolved &&
    userHasVisibilityIfTestCase
  )
}
